<template>
  <div>
    <v-subheader class="label" v-if="label.length > 0">{{ label }}</v-subheader>
    <v-layout row wrap>
      <v-flex md3>
        <input
          v-model="hour"
          label="時"
          :readonly="readonly"
          min="0"
          type="tel"
          suffix="時"
        />
      </v-flex>
      <v-flex md1>時</v-flex>
      <v-flex md3 offset-md1>
        <input
          v-model="min"
          label="分"
          :readonly="readonly"
          max="59"
          min="0"
          type="tel"
          suffix="分"
        />
      </v-flex>
      <v-flex md1>分</v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data: () => ({}),
  props: {
    value: {
      default: 0,
      type: Number,
    },
    readonly: {
      default: false,
      type: Boolean,
    },
    label: {
      default: "",
      type: String,
    },
  },
  computed: {
    hour: {
      get() {
        return Math.floor(this.value / 3600);
      },
      set(hour) {
        var numHour =
          hour.length == 0 ? 0 : parseInt(this.zenkakuTohankaku(hour));
        this.$emit("input", numHour * 3600 + this.min * 60);
      },
    },
    min: {
      get() {
        return Math.floor((this.value % 3600) / 60);
      },
      set(min) {
        var numMin = min.length == 0 ? 0 : parseInt(this.zenkakuTohankaku(min));
        this.$emit("input", this.hour * 3600 + numMin * 60);
      },
    },
  },
  methods: {
    zenkakuTohankaku(str) {
      return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
      });
    },
  },
};
</script>

